import { forwardRef, useId } from 'react';

import type { IInputProps } from '../../../interfaces/inputs';
import './CustomInput.scss';

export const CustomInput = forwardRef<HTMLInputElement, IInputProps>(
  (
    {
      id,
      label,
      helperText,
      error,
      errorSeverity = 'warning',
      prefix,
      suffix,
      containerClassName,
      className,
      ...inputProps
    },
    ref
  ) => {
    const generatedId = useId();
    const inputId = id ?? generatedId;
    const hasError = Boolean(error);

    const fieldClassName = [
      'custom-input-field',
      prefix ? 'custom-input-field--has-prefix' : '',
      suffix ? 'custom-input-field--has-suffix' : '',
      hasError ? 'custom-input-field--error' : '',
      hasError && errorSeverity === 'danger' ? 'custom-input-field--danger' : '',
      containerClassName ?? ''
    ]
      .filter(Boolean)
      .join(' ');

    const inputClassName = ['custom-input-field__input', className ?? ''].filter(Boolean).join(' ');

    return (
      <div className={fieldClassName}>
        {label && (
          <label className="custom-input-field__label" htmlFor={inputId}>
            {label}
          </label>
        )}
        <div className="custom-input-field__control">
          {prefix}
          <input
            ref={ref}
            id={inputId}
            className={inputClassName}
            aria-invalid={hasError || undefined}
            {...inputProps}
          />
          {suffix}
        </div>
        {hasError ? (
          <div className="custom-input-field__error" role="alert">
            {error}
          </div>
        ) : (
          helperText && <div className="custom-input-field__hint">{helperText}</div>
        )}
      </div>
    );
  }
);

CustomInput.displayName = 'CustomInput';

export default CustomInput;
